import { Button, Typography } from '@mui/material';
import {
  UnreadBadge,
  useAnalytics,
  METRICS_MESSAGES_ACCESS,
} from '@xolv-mybrightlink/common';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useUnreadCount } from './care-team/hooks/store/useUnreadCount';

type MessageCardStyle = {
  iconSrc: string;
  bgcolor: string;
  fontWeight: string | number;
};

const openStyle: MessageCardStyle = {
  iconSrc: '/public/assets/icons/ic_messages.svg',
  bgcolor: '#d6e5f9',
  fontWeight: 600,
};

const closeStyle: MessageCardStyle = {
  iconSrc: '/public/assets/icons/ic_messages_closed.svg',
  bgcolor: 'white',
  fontWeight: 'normal',
};

export const MessageCard = (props: { onClick: () => void; open: boolean }) => {
  const { onClick, open } = props;
  const intl = useIntl();
  const unreadCount = useUnreadCount('all');
  const style: MessageCardStyle = open ? openStyle : closeStyle;
  const analytics = useAnalytics();

  const click = useCallback(() => {
    if (!open) {
      analytics.trackAction(METRICS_MESSAGES_ACCESS);
    }
    onClick();
  }, [open, onClick, analytics]);

  return (
    <Button
      color={open ? 'primary' : 'secondary'}
      onClick={click}
      startIcon={<img src={style.iconSrc} alt='' />}
      sx={{
        color: '#3b4559',
        bgcolor: style.bgcolor,
        borderRadius: 15,
        p: 6,
        height: '50px',
        display: 'inline-flex',
        alignItems: 'center',
        mt: 1,
        mb: 5,
        boxShadow:
          '0 12px 16px 0 rgba(59, 69, 89, 0.05), 0 8px 10px 0 rgba(59, 69, 89, 0.1)',
        border: 'solid 0.5px #d8dade',
        '&:hover': {
          bgcolor: '#f7f8fb',
        },
      }}
    >
      <UnreadBadge count={unreadCount}>
        <Typography sx={{ fontSize: 14, fontWeight: style.fontWeight }}>
          {intl.formatMessage({ id: 'messages' })}
        </Typography>
      </UnreadBadge>
    </Button>
  );
};
